import { html } from "htm/preact";
import { useCallback } from "preact/hooks";

import type * as Bible from "../modules/bible";
import { dispatchEvent } from "../modules/events";

import { useBibleSettings } from "./BibleContent";

export const BibleContentVerse = ({ verse }: { verse: Bible.ContentVerse }) => {
  const settings = useBibleSettings();
  const showRelatedItems =
    verse.hasRelatedItems && settings.showVerseRelatedResources;
  if (showRelatedItems) {
    return html`<${VerseRelatedItems} verse=${verse} />`;
  }
  return html`<span class="BibleContentVerse" data-verse-id=${verse.id}
    ><span class="BibleContentVerse_content">${verse.string}</span></span
  >`;
};

const VerseRelatedItems = ({ verse }: { verse: Bible.ContentVerse }) => {
  const onClick = useCallback(() => {
    dispatchEvent("versetapped", {
      id: verse.id,
      reference: verse.reference,
    });
  }, [verse.id]);
  // TODO: <button>
  return html`<span class="BibleContentVerse" data-verse-id=${verse.id}
    ><span
      class="BibleContentVerse_content BibleContentVerse_content--related-items"
      onClick=${onClick}
      >${verse.string}</span
    ></span
  >`;
};

export function getVerseRects(node: ParentNode) {
  return Array.from(node.querySelectorAll(".BibleContentVerse")).map((node) => {
    return {
      id: parseInt(node.getAttribute("data-verse-id")!, 10),
      number: parseInt(node.textContent ?? "", 10),
      rect: node.getBoundingClientRect(),
    };
  });
}
